import { render } from "./CasebookForm.vue?vue&type=template&id=b1d787b6"
import script from "./CasebookForm.vue?vue&type=script&lang=js"
export * from "./CasebookForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__